import DOMPurify from 'dompurify';

// Dynamic field labels (checkbox/input/textarea/dropdown/file-upload) must render as
// plain text - unlike the dedicated 'label'/'html' schema field type (see field-registry's
// 'display' mode), which is the only one meant to carry real rich-text HTML. Some
// CMS-sourced labels for other field types carry incidental <p>/<span>/<ol><li> wrapping
// from their authoring tool; rendered as plain JSX text (the only option these components
// support), the raw tags would show up as literal characters. List-item/paragraph
// boundaries are turned into a "; " separator before stripping, so "<li>A</li><li>B</li>"
// reads as "A; B" instead of "AB".
export function stripFieldLabelHtml(label: string | undefined): string {
  if (!label) return '';
  const withSeparators = label.replace(/<\/(li|p)>/gi, '$&; ');
  return DOMPurify.sanitize(withSeparators, { ALLOWED_TAGS: [] })
    .replace(/\s*;\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();
}
